import { render, staticRenderFns } from "./roomDetails.vue?vue&type=template&id=a57f2996"
import script from "./roomDetails.vue?vue&type=script&lang=js"
export * from "./roomDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports